/**
 * @fileoverview A function for submitting the final launch configuration.
 *
 * @author Wyatt Lindquist (wlindquist@yext.com)
 */

import Uri from 'goog:goog.Uri';

import {Routes} from '/src/com/yext/listingslaunchstorm/js/routes';

import {doRequest} from '/src/com/yext/listingslaunchstorm/js/common/util/dorequest';
import {LaunchListingsRequest} from '/src/com/yext/listingslaunchstorm/js/data/launchlistingsrequest';

/**
  * @param {!LaunchListingsRequest} request
  * @param {AbortSignal} abortSignal
  * @return {!Promise<?>}
  */
export const launchListings = (request, abortSignal) => {
  const uri = new Uri(Routes.launchListings());
  return doRequest('launchListings', abortSignal, uri, 'POST', request.toJSON());
};
